var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background",staticStyle:{"padding-bottom":"80px","color":"white"}},[_c('BannerAula',{attrs:{"titulo":_vm.titulo,"numero":_vm.numero,"titleSize":_vm.titleSize}}),_c('v-container',{staticClass:"container px-5"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }